module.exports = __webpack_public_path__ + "static/media/vertical-logo-padding.f093028f.png";